const EMAIL_TYPE = 'EMAIL'
const SMS_TYPE = 'SMS'

export { EMAIL_TYPE, SMS_TYPE }
